<template>
  <div class="coin-header">
    <router-link
      v-for="item in visibleLinks"
      :key="item.id"
      :to="item.url"
      :class="{ active: isActive === item.id }"
      @click.native="setActive(item.id)"
    >
      {{ item.name }}
    </router-link>
  </div>
</template>
<script>
export default {
    name: 'CoinIndex',
    props: {
        link: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            isActive: 1 // 1 組別用戶 2 個人用戶
        };
    },
    computed: {
        visibleLinks() {
            return this.link.filter(item => item.show)
        }
    },
    created() {
        let flag = this.link.find(item => {
            return item.url === this.$route.path;
        });
        if (flag) {
            this.isActive = flag.id;
        }
    },
    methods: {
        setActive(val) {
            this.isActive = val;
        }
    }
};
</script>
<style lang="less" scpoed>
// @import "../../assets/css/element-reset.less";
.coin-header {
    padding: 18px 0 24px;
    a {
        display: inline-block;
        margin-right: 60px;
        font-size: 24px;
        color: #92929d;
        letter-spacing: 0.1px;
    }
    a.active {
        color: #171725;
    }
}
</style>
